<template>
  <b-card>
    <b-container>
      <b-row>
        <b-col>
          <h1>Your Order Is Complete</h1>
          <br />
          <p>Thank You! Your Order Number is {{order.OrderCode}}</p>
          <p>A confirmation email with your receipt has been sent to <b-link :href="'mailto:' + order.OrderContactInformation.Email">{{order.OrderContactInformation.Email}}</b-link>.Your order is currently being processed. When it is complete, typically within 30 minutes, you will receive a second email with links to retrieve your list in MS Excel and comma-delimited text format.</p>
          <p>If you have any questions about your order, please contact us at <b-link href="tel:8003998611">800-399-8611</b-link> or at <b-link href="mailto:orders@sl360.com">orders@sl360.com</b-link>.</p>
          <p>*Please make sure that your email's spam filter is set to allow emails from orders@sl360.com. Lists are fulfilled within 4 hours, typically under 30 minutes during normal business hours (Mon-Fri, 8am-7pm EST). Orders placed after hours from first time customers may be placed on hold for confirmation and are typically fulfilled within one business day.</p>
          <br />
          <table class="table">
            <tr>
              <td>Order Number</td>
              <td data-test="success-orderCode">{{order.OrderCode}}</td>
            </tr>
            <tr>
              <td>Order Name</td>
              <td data-test="success-orderDesc">{{order.OrderContactInformation.OrderName}}</td>
            </tr>
            <tr>
              <td>Order Date</td>
              <td data-test="success-orderDate">{{order.OrderSubmittedDate | formatDate}}</td>
            </tr>
            <tr>
              <td>Qty Available</td>
              <td data-test="success-availableQty">{{order.TotalAvailableQty | numberFormat('', 0)}}</td>
            </tr>
            <tr>
              <td>Qty Selected</td>
              <td data-test="success-selectedQty">{{order.TotalDesiredQty | numberFormat('', 0)}}</td>
            </tr>
            <!--<tr>-->
              <!--<td>Discount Values</td>-->
              <!--<td></td>-->
            <!--</tr>-->
            <tr>
              <td>Tax</td>
              <td data-test="success-tax">{{order.TaxCharge | numberFormat}}</td>
            </tr>
            <tr>
              <td>Total Charge</td>
              <td data-test="success-totalCharge">{{totalCharge | numberFormat}}</td>
            </tr>
          </table>
          <b-btn @click="goHome" variant="primary" data-test="success-goHome">Home</b-btn>
        </b-col>
      </b-row>

    </b-container>
  </b-card>
</template>

<script>
  export default {
    components:
    {
    },
    data () {
      return {}
    },
    created () {
    },
    methods: {
      goHome () {
        this.$router.push({name: 'landing'})
      }
    },
    computed: {
      site () {
        return this.$store.state.site
      },
      order () {
        return this.$store.state.order
      },
      totalCharge () {
        return this.order.TotalPretaxCost + this.order.TaxCharge
      }
    }
  }
</script>

<style scoped lang="scss">
  .row-placeorder {
    margin-top: 16px;
    display: block;
  }

  .row-placeorder-btn {
    float: right;
  }

  .bottom-btn {
    margin-top: 16px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/order/Success.vue